import service from '../utils/request';

// 登录接口
export const login = (username, password) => {
  
  return service.post('/login', {
    loginType:'ADMIN',  
    parameters:{
      username,
      password
    }
  });
};

// 获取当前用户信息
export const getCurrentUser = () => {
  return service.get('/users/current/user');
};

// 获取用户菜单和权限
export const getUserPermissions = (forceRefresh = false) => {
  // 如果需要强制刷新，添加时间戳防止缓存
  const timestamp = forceRefresh ? `?_t=${new Date().getTime()}` : '';
  
  return service.get(`/permissions/user`)
    .then(response => {
   
      
      // 确保返回的是数组格式
      if (response && response.data) {
        if (!Array.isArray(response.data)) {
          console.warn('权限API返回的不是数组格式:', response.data);
          // 如果不是数组，尝试转换或返回空数组
          return { data: [] };
        }
      }
      
      return response;
    })
    .catch(error => {
      console.error('获取权限失败:', error);
      // 如果是网络错误且未强制刷新，尝试强制刷新一次
      if (!forceRefresh && (error.message.includes('network') || error.message.includes('timeout'))) {
        console.log('尝试强制刷新权限数据...');
        return getUserPermissions(true);
      }
      throw error;
    });
};

// 登出接口
export const logout = () => {
  return service.post('/users/logout');
};

// 修改密码（旧版本，保留兼容性）
export const changePassword = (oldPassword, newPassword) => {
  return service.post('/users/{id}/password', {
    oldPassword,
    newPassword
  });
};

// 修改管理员密码
export const updateAdminPassword = (id, oldPassword, newPassword) => {
  return service({
    method: 'put',
    url: `/users/${id}/password`,
    params: {
      oldPassword,
      newPassword
    }
  });
};

// 获取管理员详情
export const getAdminById = (id) => {
  return service.get(`/users/${id}`);
};

// 更新管理员信息
export const updateAdmin = (id, adminUserDTO) => {
  return service.put(`/users/${id}`, adminUserDTO);
};

// 更新当前管理员个人信息
export const updateCurrentUser = (updateDTO) => {
  return service.put('/users/current/user', updateDTO);
};

// 更新当前管理员头像
export const updateCurrentAvatar = (avatarUpdateDTO) => {
  return service.put('/users/current/avatar', avatarUpdateDTO);
};

// 刷新token
export const refreshToken = (refreshToken) => {
  return service.post('/auth/refresh-token', { refreshToken });
}; 